/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーボタンリスト ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const FullvideoPlayerButtonlist = (props) => {
    /**
     * 指定の秒・分、巻き戻し・早送りする機能（編集ページのみ）
     */
    const [maxInputNumber, setMaxInputNumber] = useState(1); // input入力可能最大値
    const [scale, setScale] = useState(1); // 秒換算計算用倍率
    const [timeInputSecond, setTimeInputSecond] = useState(1); // input入力値の秒換算
    const refInputNumber = useRef(null); // inputのDOM
    // 総時間確定時に最大値をセット
    useEffect(() => {
        setMaxInputNumber(props.timeTotalSecond);
    }, [props.timeTotalSecond]);
    // inputの値入力時の処理
    const fnOnInputNumber = (e) => {
        const n = Number(e.target.value);
        if (isNaN(n) === true) {
            // 数値以外の場合は1に戻す
            setTimeInputSecond(1);
            e.target.value = 1;
        } else if (1 <= n && n <= maxInputNumber) {
            // 最小値と最大値の範囲内の場合はその値を反映する
            setTimeInputSecond(Math.floor(n * scale));
        } else if (maxInputNumber < n) {
            // 最大値を超える値の場合は最大値を反映する
            setTimeInputSecond(props.timeTotalSecond);
            e.target.value = maxInputNumber;
        } else {
            // それ以外の場合は1に戻す
            setTimeInputSecond(1);
            e.target.value = 1;
        }
    };
    // select変更時の処理
    const fnOnChangeSelect = (e) => {
        if (e.target.value === "min") {
            // minの場合は最大値を総時間を60で割り小数点以下を切り捨て、秒換算計算用倍率を60に
            setMaxInputNumber(Math.floor(props.timeTotalSecond / 60));
            setScale(60);
            setTimeInputSecond(60);
        } else {
            // それ以外の場合は最大値を総時間に、秒換算計算用倍率を1に
            setMaxInputNumber(props.timeTotalSecond);
            setScale(1);
            setTimeInputSecond(1);
        }
        // 変更時にはinputを1に戻す
        refInputNumber.current.value = 1;
    };

    /**
     * アイコンリスト表示状態
     */
    const [isShowSettingIconlist, setIsShowSettingIconlist] = useState(false);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnChangeSelect={fnOnChangeSelect}
            fnOnInputNumber={fnOnInputNumber}
            isShowSettingIconlist={isShowSettingIconlist}
            maxInputNumber={maxInputNumber}
            refInputNumber={refInputNumber}
            scale={scale}
            setIsShowSettingIconlist={setIsShowSettingIconlist}
            timeInputSecond={timeInputSecond}
        />
    );
};
